export default __webpack_public_path__ + "static/media/help-request-notification-sound.94f26128.mp3";